export default "__VITE_ASSET__69ko62Cj__"